<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        isNeedBillOptions: [], // 票据类型
        paystsOptions: [], // 支付状态
        orgIdOptions: [],
        form: [
          { // 业务方
            label: '业务方',
            value: 'userName',
            type: 'input',
            placeholder: '请输入业务方',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 业务单号
            label: '业务单号',
            value: 'busiCode',
            type: 'input',
            placeholder: '请输入业务单号',
          },
          { // 票据类型
            label: '票据类型',
            value: 'isNeedBill',
            type: 'select',
            default: -1,
            placeholder: '请选择票据类型',
          },
          { // 支付状态
            label: '支付状态',
            value: 'paysts',
            type: 'select',
            default: -1,
            placeholder: '请选择支付状态',
          },
          { // 支付流水号
            label: '支付流水号',
            value: 'flowId',
            type: 'input',
            placeholder: '请输入支付流水号',
          },
          { // 付款账户名
            label: '付款账户名',
            value: 'payBankAccName',
            type: 'input',
            placeholder: '请输入付款账户名',
          },
          { // 付款账号
            label: '付款账号',
            value: 'payBankAccNo',
            type: 'input',
            placeholder: '请输入付款账号',
          },
          { // 收款账户名
            label: '收款账户名',
            value: 'receivablesBankAccName',
            type: 'input',
            placeholder: '请输入支收款账户名',
          },
          { // 收款账号
            label: '收款账号',
            value: 'receivablesBankAccNo',
            type: 'input',
            placeholder: '请输入收款账号',
          },
          { // 手机号码
            label: '手机号码',
            value: 'objId',
            type: 'input',
            placeholder: '请输入手机号码',
          },
          { // 返回应答
            label: '返回应答',
            value: 'queryMsg',
            type: 'input',
            placeholder: '请输入返回应答',
          },
          { // 支付时间
            label: '支付时间',
            value: 'PayTime',
            type: 'date',
            placeholder: '请输入支付时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 完成时间
            label: '完成时间',
            value: 'Time',
            type: 'date',
            placeholder: '请输入完成时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 发车时间
            label: '发车时间',
            value: 'dependTime',
            type: 'date',
            placeholder: '请输入发车时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 客户名称
            label: '客户名称',
            value: 'customName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          { // 线路名称
            label: '线路名称',
            value: 'sourceName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 代收名称
            label: '代收名称',
            value: 'collectionUserName',
            type: 'input',
            placeholder: '请输入代收名称',
          },
          { // 订单备注
            label: '订单备注',
            value: 'orderRemark',
            type: 'input',
            placeholder: '请输入订单备注',
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            placeholder: '请选择归属部门',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 支付时间
      if (searchBoxData.PayTime) {
        searchBoxData.beginPayTime = this.formatDate(searchBoxData.PayTime[0]);
        searchBoxData.endPayTime = this.formatDate(searchBoxData.PayTime[1]);
        delete searchBoxData.PayTime;
      }
      // 完成时间
      if (searchBoxData.Time) {
        searchBoxData.finishTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
        delete searchBoxData.Time;
      }
      // 完成时间
      if (searchBoxData.dependTime) {
        searchBoxData.dependTimeStart = this.formatDate(searchBoxData.dependTime[0]);
        searchBoxData.dependTimeEnd = this.formatDate(searchBoxData.dependTime[1]);
        delete searchBoxData.dependTime;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'FUNDS_IS_NEED_BILL,RESP_CODE_TYPE',
    });
    this.searchBoxData.isNeedBillOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.paystsOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
    this.searchBoxData.orgIdOptions = await getDepartmentAllList();
  },
};
</script>

<style lang="scss" scoped>
</style>
